import * as React from "react";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkCheckbox } from "uitk-react-switch";
import { DriverAgenInRangeToggleProps } from "../typings";
import { locKeys } from "./l10n";
import { useLocalization } from "@shared-ui/localization-context";

export const DriverAgeInRangeToggle: React.FunctionComponent<DriverAgenInRangeToggleProps> = ({
  onDriverAgeInRange,
  isDriverAgeInRange,
  carConfig,
}) => {
  const { formatText } = useLocalization();
  const { driverAgeRange, driverAgeDescription } = locKeys;
  const { minRangeAge, maxRangeAge } = carConfig;

  return (
    <UitkLayoutGridItem colSpan="all">
      <div>
        <UitkCheckbox
          id="driver-age-in-range-toggle"
          label={formatText(driverAgeRange, minRangeAge, maxRangeAge)}
          description={formatText(driverAgeDescription, minRangeAge, maxRangeAge)}
          checked={!isDriverAgeInRange}
          onChange={onDriverAgeInRange}
        />
        <input
          type="hidden"
          name="ageInRange"
          value={isDriverAgeInRange.toString()}
          data-testid="driver-age-in-range-input"
        />
      </div>
    </UitkLayoutGridItem>
  );
};
